exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".zoomed-image{background-size:cover;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/styles/main.css
// module id = 3
// module chunks = 0